import { render } from "./VerObservaciones.vue?vue&type=template&id=942e88fe&scoped=true"
import script from "./VerObservaciones.vue?vue&type=script&lang=js"
export * from "./VerObservaciones.vue?vue&type=script&lang=js"

import "./VerObservaciones.vue?vue&type=style&index=0&id=942e88fe&scoped=true&lang=css"
import "../assets/general.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942e88fe"]])

export default __exports__